export const environment = {
	production: true,
	applicationServerPublicKey: `BHizkSp85qDkNe3OA_maTi-W3tO5aEPkwaCGDdMrKFyUFNUWM5cBo3ccF3aaQxo_PMheg1b71wixiqWe3YqYlkg`
};
